import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../context/authcontext";
import { useFlash } from "../../context/flashcontext";
import { useUserDetail } from "../../hooks/useUserDetail";
import UserDetailView from "./UserDetailViewModern";

function UserDetailContainer() {
    const { id } = useParams();
    const { auth } = useAuth();
    const { showFlash } = useFlash();
    const userDetail = useUserDetail(id, auth);

    // Handlers for actions
    const handleDocumentUpload = async (file, documentCategory, expires) => {
        if (!file) return showFlash("Selecteer een bestand.", "error");
        const formData = new FormData();
        formData.append("document", file);
        try {
            await userDetail.handleDocumentUpload(formData, expires, documentCategory);
            showFlash("Document geüpload.", "success");
        } catch {
            showFlash("Upload mislukt.", "error");
        }
    };

    const handleDeleteUserDocument = async (selectedDocId) => {
        try {
            await userDetail.handleDeleteUserDocument(selectedDocId);
            showFlash("Document verwijderd.", "success");
        } catch {
            showFlash("Verwijderen mislukt.", "error");
        }
    };

    const handleSaveClick = async (editableUser) => {
        try {
            await userDetail.handleSaveClick(editableUser);
            showFlash("Profiel bijgewerkt.", "success");
        } catch {
            showFlash("Bijwerken mislukt.", "error");
        }
    };

    return (
        <UserDetailView
            {...userDetail}
            auth={auth}
            onDocumentUpload={handleDocumentUpload}
            onDeleteUserDocument={handleDeleteUserDocument}
            onSaveClick={handleSaveClick}
        />
    );
}

export default UserDetailContainer;

UserDetailContainer.propTypes = {
    // No props - uses useParams
};
